import React from 'react'
import Invoice5Container from '../../../../../Components/Apps/ECommerce/Invoices/Invoice5'

export default function Invoice5() {
  return (
    <div className='page-body'>
        <Invoice5Container/>
    </div>
  )
}
